import React from 'react';
import cn from 'classnames';
import { Button } from 'antd';
import type { IProduct, ISpuInfo, IVariant } from 'base/interfaces/product';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';
import { useTrans } from 'base/utils/i18n';

export type IQuickViewData = {
    productSpu: ISpuInfo;
    variant: IVariant;
}

export type ListProductQuickViewProps = {
    product: IProduct;
    onQuickView: (variantId: string) => void;
};

const ListProductQuickView: React.FC<ListProductQuickViewProps> = props => {
    const { t } = useTrans()

    const {
        product,
        onQuickView
    } = props;

    return (
        <div className={cn(styles['quick-view'], 'quick-view')}>
            <Button
                icon={<Iconfont className={'icon-eye'}/>}
                className={styles.btn}
                onClick={(e: any) => {
                    e.stopPropagation()
                    onQuickView(product.variantId)
                }}
            >
                {t('web_common_btn_quick_view')}
            </Button>
        </div>
    )
};

export default ListProductQuickView;